export default __webpack_public_path__ + "static/media/aboutslider4.3a8cb2e2.webp";